<app-page-title title="Connecteurs"></app-page-title>
<mat-tab-group mat-align-tabs="center">
  <mat-tab *ngIf="connectorKwFrance!=null">
    <ng-template mat-tab-label>{{connectorKwFranceDisplayName}}</ng-template>
    <ng-template matTabContent>
      <app-connector-user [code]="ConnectorCode.KWFRANCE"></app-connector-user>
    </ng-template>
  </mat-tab>
</mat-tab-group>
